import Cookies from 'js-cookie';

import { ContentPlacement } from '@candu-ai/placement/types';

import { cookieDomain } from './cookieDomain';

interface SetForceSnapshotCookieProps {
  url: string;
  applicationId: number;
  contentId: string;
  removeSnapshotId?: string;
  placement?: ContentPlacement;
}

export const setForceSnapshotCookie = ({
  url,
  applicationId,
  contentId,
  removeSnapshotId,
  placement,
}: SetForceSnapshotCookieProps) => {
  Cookies.set(
    'forceSnapshot',
    JSON.stringify({
      destination: url,
      start: true,
      props: {
        applicationId,
        contentId,
        removeSnapshotId,
        placement,
      },
    }),
    {
      domain: cookieDomain(),
    },
  );
};
